export enum LoggerLevelEnum  {
  Trace = 0,
  Debug = 1,
  Info = 2,
  Warn = 4,
  Error = 5,
  Fatal = 6
}
